// @flow
import React from 'react';
import Box from '@waglabs/box';
import Flex from '@waglabs/flex';
import H2 from '@waglabs/h2';

import { PlanCard } from './components/PlanCard';

import {
  WAG_TAG_PLAN_BASIC,
  WAG_TAG_PLAN_PREMIUM,
} from '../../../../constants';

import { plans } from './assets/plans';

type Props = {
  search: string,
};

export const PlansBlock = ({
  search,
}: Props) => (
  <Flex
    alignItems="center"
    flexDirection="column"
    mb={5}
    mt={0}
    width={1}
  >
    <Box
      width={1}
    >
      <H2
        color="medGray"
        fontFamily="bodyMuli"
        fontSize={[8, 9, 10]}
        fontWeight="bold"
        mb={[3, 4, 4, 5]}
        textAlign="center"
      >
        The Plans
      </H2>

      <Flex
        justifyContent="center"
        flexDirection={['column', 'row']}
        alignItems={['center', 'stretch']}
      >
        {plans.map((plan) => {
          const {
            key,
            planType,
          } = plan;

          const isWagTagEssentialPlanCard = planType === WAG_TAG_PLAN_BASIC;
          const isWagTagCompletePlanCard = planType === WAG_TAG_PLAN_PREMIUM;

          return (
            <PlanCard
              key={key}
              mb={[isWagTagEssentialPlanCard ? 5 : 0, 0]}
              mr={[0, 3, isWagTagCompletePlanCard ? 0 : 5]}
              plan={plan}
              pt={[0, isWagTagEssentialPlanCard ? '32px' : 0]}
              search={search}
            />
          );
        })}
      </Flex>
    </Box>
  </Flex>
);
